import { render, staticRenderFns } from "./TileComments.vue?vue&type=template&id=d6643d66"
import script from "./TileComments.vue?vue&type=script&lang=js"
export * from "./TileComments.vue?vue&type=script&lang=js"
import style0 from "./TileComments.vue?vue&type=style&index=0&id=d6643d66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports